export default "__VITE_ASSET__BixdRwz3__"